import { Fragment, ReactNode } from 'react';
type WysiwygProps = {
  children?: ReactNode,
  content?: any
  listItems?: boolean | undefined
  paragraph?: string,
  wysiwygClasses?: string
}
const Wysiwyg = ({ wysiwygClasses, content, listItems, children, paragraph }: WysiwygProps) => (
  <Fragment>
    {listItems && <ul  className={ `wysiwyg-list ${wysiwygClasses ?? ''}` } dangerouslySetInnerHTML={ { __html: content } } />}
    {!listItems && <div className={ `wysiwyg-section ${wysiwygClasses ?? ''} ${paragraph ? 'paragraph ' : ''}` } dangerouslySetInnerHTML={ { __html: content } }>
      {children}
    </div>} 
  </Fragment>
);

export default Wysiwyg;
